import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import map from 'lodash/map'
import { PurchaseOrderPaymentStatusEnum, PurchaseOrderStatusEnum } from '@ztechapps/common.contract'

const purchaseOrderPaymentStatuses = map(PurchaseOrderPaymentStatusEnum, (e) => {
  return e
})

const purchaseOrderStatuses = map(PurchaseOrderStatusEnum, (e) => {
  return e
})

export const purchaseOrderListFieldConfig: ListFieldConfig = {
  code: { name: 'code', displayName: 'Code', defaultOnSearch: true, size: 100, index: 0 },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: purchaseOrderStatuses,
    },
    size: 100,
    index: 1,
  },
  purchaseDate: {
    name: 'purchaseDate',
    displayName: 'Purchase date',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 200,
    index: 3,
  },
  estimatedArrivalDate: {
    name: 'estimatedArrivalDate',
    displayName: 'Est. arrival date',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 200,
    index: 4,
  },
  vendor: { name: 'vendor.company.name', displayName: 'Vendor Name', size: 300, index: 5 },
  netAmount: { name: 'net', size: 100, index: 6, type: ListFieldTypeEnum.number },
  paymentStatus: {
    name: 'paymentStatus',
    displayName: 'Payment status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: purchaseOrderPaymentStatuses,
    },
    size: 150,
    index: 7,
  },
  remarks: { name: 'remarks', size: 300, index: 8 },

  contactName: { name: 'vendor.profile.name', displayName: 'Contact Name', size: 300, isVisible: false },
  contactPhone: { name: 'vendor.phone', displayName: 'Contact Phone', isVisible: false },
  tags: { name: 'tags', excludeOnSort: true, size: 120, isVisible: false },
}
